import script from "./EditPhoneNumberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPhoneNumberModal.vue?vue&type=script&setup=true&lang=js"

import "./EditPhoneNumberModal.vue?vue&type=style&index=0&id=3977e276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3977e276"]])

export default __exports__